import Vue from 'vue';
import VueRouter from 'vue-router';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Scenario from '../../models/Scenario';
import Modal from './../../components/Modal';
import TopSuccess from './../../components/TopSuccess';
import TopWarning from './../../components/TopWarning.vue';
import TopError from './../../components/TopError';

import MotorSelector from '../../components/MotorSelector';

@Component({
    props: {
        type: {
            type: String,
            default: 'iron-core',
        },
    },
    computed: mapState({
        scenarios: state => state.scenarios.scenarios,
    }),
})
export default class Motors extends Vue {
    name = 'motor-details';

    showQuoteDialog = false;
    showHelpDialog = false;
    selectedScenario = -1;

    successMessage = '';
    helpMessage = '';
    errorMessage = '';
    warning = '';
    helpContact = '';

    quoteMessage = '';

    requestingQuote = false;
    requestingHelp = false;

    share = false;
    requestingShare = false;
    shareMessage = '';

    /* eslint-disable no-useless-escape */
    emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    mounted() {
        this.$eventHub.$on('request-quote', this.quoteDialog);
        this.$eventHub.$on('request-help', this.helpDialog);
        this.$eventHub.$on('request-share', this.getShareDialog);
        this.$eventHub.$on('request-pdf', () => {
            this.$eventHub.$emit('request-pdf-complete');
        });
    }

    get series() {
        return this.$store.getters.getMotorType(this.type) || {};
    }

    get properties() {
        let properties;
        if (this.series.properties && this.series.properties[this.$i18n.locale]) {
            properties = this.series.properties[this.$i18n.locale];
        } else if (this.series.properties && this.series.properties[this.$i18n.fallbackLocale]) {
            properties = this.series.properties[this.$i18n.fallbackLocale];
        }
        return properties || {};
    }

    get seriesName() {
        return this.properties.name || this.series.name || '';
    }

    get subtitle() {
        return this.properties.subtitle || this.series.subtitle || '';
    }

    get short_description() {
        return this.properties.short_description || this.series.short_description || '';
    }

    select(motor) {

        this.$store.dispatch('setSelectedMotor', motor);
        this.$eventHub.$emit('motor-changed', {
            isTorque:
                motor.name !== undefined &&
                motor.name !== null &&
                motor.name.toLowerCase().startsWith('q'),
        });

        const path = '/scenarios';
        if (this.$route.path !== path) this.$router.push(path);
    }

    beforeDestroy() {
        this.$eventHub.$off('request-quote', this.quoteDialog);
        this.$eventHub.$off('request-help', this.helpDialog);
        this.$eventHub.$off('request-share', this.getShareDialog);
        this.$eventHub.$off('request-pdf');
    }

    quoteDialog() {
        this.showQuoteDialog = true;
    }

    helpDialog() {
        this.showHelpDialog = true;
    }

    closeDialogs() {
        this.showQuoteDialog = false;
        this.showHelpDialog = false;
        this.selectedScenario = -1;

        this.requestingQuote = false;
        this.requestingHelp = false;

        this.share = false;
        this.shareEmail = undefined;
        this.requestingShare = false;
        this.shareMessage = '';

        this.$eventHub.$emit('request-quote-complete');
        this.$eventHub.$emit('request-help-complete');
    }

    quote() {
        if (this.selectedScenario !== -1) {
            this.requestingQuote = true;
            Scenario.quote(this.selectedScenario, this.quoteMessage)
                .then(() => {
                    this.requestingQuote = false;
                    this.closeDialogs();
                    this.quoteMessage = '';
                    this.success(this.$t('common.modals.successMessages.contactShortly'), 5000);
                })
                .catch(err => {
                    this.error(this.$t('common.errorTryAgain'), 5000);
                    console.warn('[ quote ] Something went wrong.', err);
                });
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    warn(text, duration = 5000) {
        this.warning = text;

        setTimeout(() => {
            this.warning = undefined;
        }, duration);
    }

    error(text, duration = 5000) {
        this.errorMessage = text;

        setTimeout(() => {
            this.errorMessage = undefined;
        }, duration);
    }

    success(text, duration = 5000) {
        this.successMessage = text;

        setTimeout(() => {
            this.successMessage = undefined;
        }, duration);
    }

    help() {
        if (this.selectedScenario !== -1) {
            this.requestingHelp = true;
            Scenario.help(this.selectedScenario, this.helpMessage, this.helpContact)
                .then(() => {
                    this.requestingHelp = false;
                    this.closeDialogs();
                    this.helpMessage = null;
                    this.helpContact = null;
                    this.success(this.$t('common.modals.successMessages.weWillHelp'));
                })
                .catch(err => {
                    this.error(this.$t('common.errorTryAgain'), 5000);
                    console.warn('Quote error', err);
                });
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    getShareDialog() {
        this.share = true;
        this.shareEmail = null;
        this.shareMessage = null;
    }

    shareScenario() {
        if (this.selectedScenario !== -1) {
            if (this.emailPattern.test(this.shareEmail)) {
                this.requestingShare = true;
                Scenario.share(this.selectedScenario, this.shareEmail, this.shareMessage)
                    .then(() => {
                        this.success(
                            this.$t('common.modals.successMessages.scenarioBeenShared', {
                                shareEmail: this.shareEmail,
                            }),
                            5000,
                        );
                        this.closeDialogs();
                    })
                    .catch(err => {
                        if (!this.emailPattern.test(this.shareEmail)) {
                            this.error(this.$t('common.errorEmailNotValid'), 5000);
                            console.warn('Quote error', err);
                        } else {
                            this.error(this.$t('common.errorTryAgain'), 5000);
                            console.warn('Quote error', err);
                        }

                        this.closeDialogs();
                    });
            } else {
                this.error(this.$t('common.errorEmailNotValid'));
            }
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    changeSerie() {
        this.$router.go(-1);
    }
}

Vue.component('motors', Motors);
